import { render, staticRenderFns } from "./RenewalProposal.vue?vue&type=template&id=ade5bff8&scoped=true&"
import script from "./RenewalProposal.vue?vue&type=script&lang=js&"
export * from "./RenewalProposal.vue?vue&type=script&lang=js&"
import style0 from "./RenewalProposal.vue?vue&type=style&index=0&id=ade5bff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade5bff8",
  null
  
)

export default component.exports